import React from 'react';
import { Subscription, SubscriptionStatus } from '../../types';
import { Card, CardContent } from "@pagespeedify/ui";

interface TrialStatusProps {
  subscription: Subscription;
}

export function TrialStatus({ subscription }: TrialStatusProps) {
  // Only show for trial subscriptions
  if (subscription.status !== SubscriptionStatus.TRIALING) {
    return null;
  }
  
  const trialEndsAt = subscription.trial_ends_at ? new Date(subscription.trial_ends_at) : null;
  
  if (!trialEndsAt) {
    return null;
  }
  
  // Calculate days remaining
  const now = new Date();
  const daysRemaining = Math.ceil((trialEndsAt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  
  return (
    <Card className="bg-blue-50 border-blue-200">
      <CardContent className="pt-6">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">Trial Status</h3>
            <div className="mt-2 text-sm text-blue-700">
              {daysRemaining > 0 ? (
                <>
                  <p>Your trial ends in <strong>{daysRemaining} day{daysRemaining !== 1 ? 's' : ''}</strong> on {trialEndsAt.toLocaleDateString()}.</p>
                  <p className="mt-1">You'll be automatically subscribed to the <strong>{subscription.plan_name}</strong> plan after your trial period ends.</p>
                </>
              ) : (
                <p>Your trial has ended. Your subscription will be processed soon.</p>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}